package com.martdev.flickq.showtime.model

enum class ShowtimeStatus {
    SCHEDULED, CANCELLED, COMPLETED
}